import React from 'react';
import { connect } from 'react-redux'
import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Form, Divider, Radio, Input } from 'antd';

import { _success, _setAxios, _validationFormMsg, _fmtRupiah, _isNumber } from '../../../../lib/Helper';
import { SelectBiaya, SelectTingkatanKelas, SelectSiswa, SelectTahunAjaran } from '../../../../components/select';
import { jenisBiayaOptions } from '../../../../data/options';

import "./style.css"

const { TextArea } = Input;

const schema = {
    siswa: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    tahun_ajaran_id: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    biaya: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    jenis_biaya: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
    nominal: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {
            },
            errors: {},
            loading: false,
            visible: false,
            keyword: {
                siswa: null,
            }
        };
    }

    componentDidMount() {
        this.setState({
            values: {
                ...this.props.data,
                jenis_biaya: this.props.data.nominal ? (parseInt(this.props.data.nominal) > 0 ? "Debit" : "Kredit") : "",
            },
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            _validationFormMsg(errors)
            return
        }

        this.setState({
            loading: true
        });

        values.nominal = values.nominal ? _isNumber(values.nominal) : 0
        const params = {
            siswa_id: values.siswa ? values.siswa : null,
            tingkatan_kelas: values.tingkatan_kelas ? values.tingkatan_kelas : null,
            tahun_ajaran_id: values.tahun_ajaran_id ? values.tahun_ajaran_id : null,
            pemasukan_detail_id: values.biaya ? values.biaya : null,
            nominal: parseInt(values.jenis_biaya === "Kredit" ? "-" + values.nominal : values.nominal),
            keterangan: values.keterangan ? values.keterangan : null,
        }

        let endpoint = "keuangan/pemasukan/biaya-opsional"
        let method = "POST"
        if (values.id) {
            endpoint = endpoint + "/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };


    render() {
        const { values } = this.state
        const { data } = this.props

        return (
            <Modal
                maskClosable={false}
                title={"Form Biaya Opsional"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Siswa *">
                                <SelectSiswa
                                    defaultValue={data.siswa_obj.id ? data.siswa_obj : null}
                                    value={this.state.values.siswa}
                                    onChange={(val, row) => {
                                        this.handleChangeSetValue("siswa", val ? val : null)
                                        this.handleChangeSetValue("biaya", null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Tingkatan Kelas *">
                                <SelectTingkatanKelas
                                    defaultValue={data.tingkatan_kelas}
                                    value={values.tingkatan_kelas}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("tingkatan_kelas", val ? val : null)
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                            <Form.Item label="Tahun Ajaran *">
                                <SelectTahunAjaran
                                    defaultValue={data.tahun_ajaran_id}
                                    value={values.tahun_ajaran_id}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("tahun_ajaran_id", val ? val : null)
                                        this.handleChangeSetValue("biaya", null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Biaya *">
                                <SelectBiaya
                                    disabled={!values.tingkatan_kelas || !values.tahun_ajaran_id || !values.siswa ? true : false}
                                    tahunAjaranId={values.tahun_ajaran_id ? values.tahun_ajaran_id : ""}
                                    tingkatanKelas={values.tingkatan_kelas ? values.tingkatan_kelas : ""}
                                    defaultValue={data.biaya}
                                    value={values.biaya}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("biaya", val ? val : null)
                                    }}
                                />
                            </Form.Item>
                            <Form.Item label="Jenis Biaya *">
                                <Radio.Group
                                    defaultValue={data.jenis_biaya}
                                    value={values.jenis_biaya}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("jenis_biaya", e ? e.target.value : null)
                                    }}>
                                    {jenisBiayaOptions.map((row, i) => {
                                        return <Radio key={i} value={row.value}>{row.label}</Radio>
                                    })}
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item label="Nominal *">
                                <Input
                                    addonBefore={"Rp."}
                                    style={{ width: '100%' }}
                                    name="nominal"
                                    placeholder="0"
                                    defaultValue={data.nominal}
                                    value={values.nominal ? _fmtRupiah(values.nominal) : null}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nominal", e.target.value)
                                    }} />
                            </Form.Item>
                            <Form.Item label="Keterangan">
                                <TextArea
                                    rows={4}
                                    placeholder="Keterangan"
                                    defaultValue={data.keterangan}
                                    value={values.keterangan}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("keterangan", e.target.value)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(FormContent);
